const wageData = require("../../../db/wage.json");

// 定員人数によってjson keyを所得
function convert(num) {
  if (num < 26) {
    return "num25"
  } else if (num >= 26 && num < 51) {
    return "num26_50"
  } else if (num >= 51 && num < 81) {
    return "num51_80"
  } else if (num >= 81 && num < 101) {
    return "num81_100"
  } else if (num >= 101 && num < 151) {
    return "num101_150"
  } else if (num >= 151 && num < 201) {
    return "num151_200"
  }

  throw new Error("定員超え");
}


// checkboxのcheckが入った値を所得
function getCheckedItems(checkboxes) {
  const items = [];
  for (const checkbox of Array.from(checkboxes)) {
    if (checkbox.checked) {
      items.push(checkbox.value);
    }
  }

  return items;
}

// inputの値から時給を所得
function getWageByPref(id) {
  let wage;

  const wageArray = Array.from(JSON.parse(JSON.stringify(wageData)));

  for (const pref of wageArray) {
    if (pref.id === id && "wage" in pref) wage = pref.wage;
  }

  return wage;
}

// 必須項目の値があるかを確認
function checkFields(inputs) {
  const allValuesSet = Object.keys(inputs).every(input => {
    if (input === "options") {
      return inputs[input].length > 0;
    }
    return inputs[input];
  })

  return allValuesSet;

}

// optionsのインプットから委託内容のKEYを所得
function getKeyByOptions(options) {

  if (options.indexOf("operation-management") >= 0 && options.indexOf("food-service") >= 0) {
    return "ab";
  } else if (options.indexOf("operation-management") >= 0) {
     return "b";
  } else if (options.indexOf("food-service") >= 0) {
    return "a";
  }
}


module.exports = {
  getCheckedItems,
  convert,
  getWageByPref,
  checkFields,
  getKeyByOptions
}


